import React from "react";
import useGames from "../../hooks/queryResults/useGames";
import useWeek from "../../hooks/queryResults/useWeek";
import Box from "../layout/Box";
import Loading from "../ui/Loading";
import GameSummary from "./GameSummary";
import styled from "styled-components";

const StyledDivContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
`;

export default function WeekGameSummaries({ style, size }) {
  const { selectedWeek } = useWeek();
  const {
    gamesCollection: allGames,
    gamesQuery,
    teamsQuery,
  } = useGames(selectedWeek);

  let loading = false;
  if (gamesQuery.isLoading || teamsQuery.isLoading) loading = true;

  const loaded = gamesQuery.isSuccess && teamsQuery.isSuccess;

  size = size || "lg";

  let gameSummaries = null;
  if (loaded) {
    const games = allGames.getGamesByWeek(selectedWeek);
    if (!games || games.length === 0) gameSummaries = "No games scheduled.";
    else
      gameSummaries = games.map((game, i) => {
        return <GameSummary key={i} game={game} size={size} />;
      });
  }

  return (
    <Box style={style} title={`games - week ${selectedWeek}`}>
      {!loaded || loading ? (
        <Loading />
      ) : (
        <StyledDivContainer>{gameSummaries}</StyledDivContainer>
      )}
    </Box>
  );
}
